import { render, staticRenderFns } from "./MainFileUpload.vue?vue&type=template&id=6677809a&scoped=true"
import script from "./MainFileUpload.vue?vue&type=script&lang=js"
export * from "./MainFileUpload.vue?vue&type=script&lang=js"
import style0 from "./MainFileUpload.vue?vue&type=style&index=0&id=6677809a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6677809a",
  null
  
)

export default component.exports